import { useEffect } from "react";

/**
 * Sets the document title on route change.
 * Keeps behaviour explicit — no react-helmet needed for a small site.
 */
export default function usePageTitle(title) {
  useEffect(() => {
    if (!title) return;
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
